import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import UserReportLayer from '../components/reports/UserReportLayer'

export const UserReportPage = () => {
  return (
   <MasterLayout>
    <UserReportLayer />
   </MasterLayout>
  );
};

export default UserReportPage;